import { Box, Typography } from '@mui/material'
export const CustomNoRowsOverlay = () => (
  <Box sx={{ p: 2, textAlign: 'center' }}>
    <Typography variant="body2">No data available.</Typography>
  </Box>
)
